const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 201.75 32.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.21,24.37c-1.65,0-2.7.1-3.72-.02-1.8-.21-2.62-1.45-2.42-3.12.23-1.96,1.97-3.25,3.53-2.68,2.18.78,4.34.84,6.6.54,2.99-.39,4.41,1.27,3.67,4.17-.08.32-.2.65-.39.91-3.36,4.5-7.44,7.91-13.25,8.69-4.46.6-8.62-3.85-9.74-7.02-2.43-6.87.48-13.56,7.01-17.23,4.48-2.51,9.38-3.05,14.39-2.23,1.8.3,2.27,1.94,1.93,3.46-.33,1.48-1.49,2.39-3.17,1.97-4.85-1.2-9.13-.04-12.93,3.08-2.68,2.2-3.59,6.63-2.06,9.73,1.44,2.91,4.23,3.81,7.04,2.2,1.04-.6,1.98-1.38,3.49-2.45Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.77,9.57c-4.96,1.27-9.58-.08-13.95,1.74-1.24.52-2.36-.34-3.02-1.56-.73-1.33-.31-2.43.73-3.31.98-.82,2.2-1.03,3.48-1.09,4.73-.21,9.51-.12,14.16-.85,4.73-.75,9.55.43,14.23-1.05,1.3-.41,2.92-.13,3.27,1.74.35,1.88-.46,2.95-2.4,3.29-2.36.41-4.7,1.08-7.12.9-2.23-.17-3.64.65-4.75,2.67-1.6,2.9-3.2,5.78-4.35,8.88-.53,1.43-1.02,2.79-.6,4.51.34,1.37-.67,2.87-1.95,3.69-.92.58-2.2.68-3.08,0-1.4-1.09-1.51-2.81-1.08-4.35,1.28-4.61,2.91-9.1,5.35-13.26.25-.42.47-.85,1.09-1.97Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.26,3.78c-.09,3.47-1.63,6.37-3.76,8.97-2.5,3.05-4.42,6.29-5.09,10.3-.32,1.94.29,1.77,1.68,1.64,5.88-.54,11.77-.61,17.65.12,1.39.17,2.63.58,3.25,1.93.43.94.48,1.93-.24,2.81-.66.81-1.56,1.58-2.54,1.17-4.82-2-9.81-1.03-14.73-.98-2.36.02-4.74-.08-7.09.91-1.81.76-2.96-.62-3.2-2.43-.74-5.65.68-10.8,3.79-15.52,1.36-2.07,3.25-3.77,4.24-6.11.42-.99.98-1.95.92-3.04C9.03,1.48,9.92-.12,11.96,0c1.93.12,2.46,1.92,2.31,3.78Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,22.57c2.73-.74,4.69-2.16,6.03-4.35,1.38-2.25,2.44-4.66,3.1-7.24.4-1.58,1.39-2.79,3.12-2.52,1.84.29,2.23,1.86,1.88,3.45-1.8,8.35-5.98,14.56-14.76,16.37-3.16.65-5.24-1.2-4.96-4.4.26-2.97.63-5.93,1.02-8.89.21-1.63.9-2.75,2.88-2.64,1.98.11,2.3,1.53,2.28,2.92-.03,2.37-.36,4.74-.58,7.31Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.01,13.29c-.18-.25-.46-.51-.49-.79-.41-3.57-1.1-4.12-4.5-3.52-2.6.46-5.2.96-7.81,1.41-6.28,1.08-10.55,5.1-11.81,11.14-.9,4.32.8,6.33,5.74,6.33,1.19-.14,2.77-.22,4.32-.51,4.03-.76,8.24-.82,11.93-3.03,4.43-2.66,5.51-7.04,2.63-11.02ZM126.11,19.41c-2.15,1.8-4.85,1.9-7.41,2.31-2.26.37-4.53.98-7.16.58.76-3.18,2.59-5.36,5.59-6.11,2.89-.72,5.79-2.46,8.91-.2,1.83,1.33,1.48,2.23.07,3.41Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.45,13.87c-.82-2.05-2.74-2.82-4.78-3.02-6.97-.7-14.14,3.87-16.49,10.48-.3.84-.76,1.68-.59,2.55.02,3.1,1.86,5.26,4.42,4.91,6.56-.9,12.56-2.99,16.51-8.83,1.27-1.88,1.79-3.96.93-6.09ZM43.04,23.46c2.12-5.29,6.08-7.21,11.5-7.5-2.34,5.07-6.8,6.22-11.5,7.5Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9c93ea85c1dc3944b857cb1bdca5d390.svg";
export { ForwardRef as ReactComponent };